<template>
	<div class="intro" >
		<!-- <img src="@/assets/images/logo.png" class="logo"/> -->

		<div class="video">

			<iframe @ended="skipFlashPage" class="embed-responsive-item" id="ytplayer" type="text/html" width="100%" height="100%" src="https://www.youtube.com/embed/QhzjAS3SPqk?&autoplay=1&loop=1&mute=1&rel=0&showinfo=0&controls=1&color=white&iv_load_policy=3&playlist=QhzjAS3SPqk" frameborder="0" allow="autoplay; fullscreen" ></iframe>

			<!-- <iframe width="560" height="315" src="https://www.youtube.com/embed/QhzjAS3SPqk" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> -->

			<!-- <vimeo-player
			ref="player"
			:video-id="644998104"
			@ended="skipFlashPage"
			:options="{ responsive: true, background: true }"
			/> -->

		</div>

		<button
			type="button"
			class="skipVideo"
			@click.prevent="skipFlashPage"
			>
			Skip Intro
		</button>

</div>
</template>

<script>
export default {
	name: "IntroVideo",
	props: ["skipFlashPage"],
};
</script>

<style lang="scss" scoped>
.intro {
	height: 100vh;
	width: 100%;
	overflow: hidden;
	position: fixed;
	top: 0;
	z-index: 999;
	background: theme-var($--ch-theme-primary);
	.video {
		width: 100% !important;
		height: 100vh !important;
		min-width: 1400px;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		z-index: 0;
		display: flex;
		flex-direction: column;
		flex-wrap: nowrap;
		justify-content: center;

		// &::after {
		// 	content: "";
		// 	width: 100%;
		// 	height: 100%;
		// 	position: absolute;
		// 	left: 0;
		// 	top: 0;
		// 	background: #0000006b;
		// }
	}
	.logo{
		position: absolute;
		left: 62px;
		top: 55px;
		z-index: 1;
		width: 110px;
		height: 110px;
	}
	.skipVideo{
		background: #CC3433;
		border-radius: 55px;
		border:none;
		padding: 8px 60px 8px 60px;
		color:white;
		display:flex;
		justify-content: flex-end;
		align-items:flex-end;
		font-family: 'Verlag Condensed Bold';
		font-style: normal;
		font-weight: 400;
		font-size: 25px;
		line-height: 100%;
		text-transform: uppercase;
		position: absolute;
		    z-index: 1000;
		// z-index: 1;
		text-align: center;
		right: 6%;
		transform: translateX(-6%);
		bottom: 80px;
		@include media-breakpoint-down(sm) {
			padding: 5px 25px 5px 25px;
			font-size: 16px;
			top:20px;
			bottom:unset;
			left: 2%;
			right:unset;
			transform: translateX(-2%);
			justify-content: center;
			align-items:center;
			// position: absolute;
			// bottom: 180px;
			// right: 10%;
			// transform: translateX(-10%);
		}
		&::after {
			content: url("~images/icons/small.svg");
			position: absolute;
    		right: 30px;
			@include media-breakpoint-down(sm) {
				right: 5px;
			}
			// position: absolute;
			// right: 10px;
			// top: 50%;
			// transform: translateX(-6%, -50%);
			// background: #0000006b;
		}
	}
}

</style>
